export enum CompetitorCategory {
  PRICING = 'pricing',
  FEATURES = 'features',
  IMPLEMENTATION = 'implementation',
  SUPPORT = 'support',
  PERFORMANCE = 'performance',
  RELIABILITY = 'reliability',
  OTHER = 'other'
}

export interface CompetitorAdvantage {
  _id?: string;
  point: string;
  category: CompetitorCategory;
  evidence?: string;
}

export interface CompetitorWeakness {
  _id?: string;
  point: string;
  category: CompetitorCategory;
}